import React from "react";
import PropTypes from "prop-types";
import Constants from "../../utils/Constants";

function StaticMediaLink({ url, children, classNames }) {
  // not using Link from react-router as below is an external link
  return (
    <a
      href={Constants.STATIC_MEDIA_URL + url}
      className={classNames}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </a>
  );
}

StaticMediaLink.defaultProps = {
  classNames: "",
};

StaticMediaLink.propTypes = {
  url: PropTypes.string.isRequired,
  classNames: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default StaticMediaLink;
